import React, { useCallback, useEffect, useState, useRef } from "react";
import ExpandableSearch from "../../components/Common/ExpandableSearch";
import GenericModal from "../../components/Modals/GenericModal";
import NewGroupChatModal from "../../components/Modals/NewGroupChatModal";
import ChatWindow from "../../components/pages/Chat/ChatWindow";
import UserList from "../../components/pages/Chat/UserList";
import { Assets } from "../../constants/images";
import { tableLoader } from "../../utils/helper";
import {
  NoDataIcon,
  RoundedEditIcon,
  ToastCrossIcon,
  ToastRedTrashIcon,
} from "../../constants/svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllUsers,
  setIsAllUsersLoading,
  setSelectedUser,
} from "../../store/slices/chatsSlice";
import {
  convertFirebaseTimestamps,
  getChatUserList,
  isSuperAdmin,
  signInToFirebase,
  updateFirebaseUser,
  updateLastOpenTime,
} from "../../services/chats/frontend-chats";
import { GetChatUsers, GetMembers } from "../../services/team/member";
import { Image, notification } from "antd";
import { GetAuthUserLocalStorage } from "../../services/localStorage/localStorage";
import NewChat from "../../components/pages/Chat/NewChat";
import {
  setIsSalonTeamsLoading,
  setSalonTeams,
} from "../../store/slices/salonTeamsSlice";
import { GetSalonTeams } from "../../services/salonTeams/salonTeams";
import { getChatUsers } from "../../services/chats/chatusers";
import ChatWindowV2 from "../../components/pages/Chat/ChatWindowV2";

const Chat = () => {
  const authUser = GetAuthUserLocalStorage();
  const [newChat, setNewChat] = useState(false);
  const [newChatDefault, setNewChatDefault] = useState(true);
  const [selectedUserGroup, setSelectedUserGroup] = useState(null);
  const [showGenericModal, setShowGenericModal] = useState(false);
  const dispatch = useDispatch();
  const { me } = useSelector((state) => state.auth);
  const { userListing, selectedUser } = useSelector((state) => state?.chats);
  const [searchText, setSearchText] = useState("");
  const [hasInitialLoad, setHasInitialLoad] = useState(false);
  const newChatRef = useRef(null);

  const handleItemClick = async (user) => {
    const sanitizedUser = convertFirebaseTimestamps(user);
    dispatch(setSelectedUser(sanitizedUser));
    // Update last open time when user clicks on a chat item
    if (user?.chat_id && me?.data?.id) {
      try {
        await updateLastOpenTime(user.chat_id, me.data.id);
      } catch (error) {
        console.error("Error updating last open time:", error);
      }
    }
  };

  // const handleItemClick = (user) => {
  //   setSelectedUser(user);
  //   setNewChat(false);
  //   setSelectedUserGroup(false);
  // };

  const handleNewGroupChatFunc = useCallback(() => {
    setShowGenericModal(false);
    setSelectedUserGroup([
      {
        id: 1,
        avatar: Assets.ProfileAvatarOne,
        username: "John Doe",
        isOnline: true,
        sendingTime: "1h ago",
        chatHistory: [
          {
            sender: "John Doe",
            content: "Hello, how are you?",
            time: "10:00 AM",
            date: "2023-05-19",
            timeSpan: "Yesterday",
          },
          {
            sender: "June Julino",
            content: "I'm good, thank you!",
            time: "10:02 AM",
            date: "2023-05-19",
            timeSpan: "",
          },
        ],
      },
    ]);
  }, []);

  const fetchChatUserList = async () => {
    if (me?.data?.id) {
      console.log("fetchChatUserList");
      getChatUserList(dispatch, me?.data?.id);
    }
  };

  const fetchAllUsers = async () => {
    console.log("fetchAllUsers called");
    dispatch(setIsAllUsersLoading(true));
    let response;
    if (isSuperAdmin) {
      response = await GetChatUsers({ light: 1 });
    } else {
      response = await GetMembers();
    }
    const { data, status, message } = response.data;
    if (!status) {
      notification.error({
        description: message,
        placement: "bottomRight",
        className: "createdNotification",
        closeIcon: <ToastCrossIcon />,
      });
      return;
    }
    dispatch(setIsAllUsersLoading(false));
    const users = isSuperAdmin ? data : data.users;
    dispatch(setAllUsers(users));
    // await getAllUsers(dispatch,null,me?.data?.salon_id)
    return users;
  };

  const filteredUsers = userListing?.data?.filter((user) => {
    if (user?.is_group_chat) {
      return user?.name?.toLowerCase().includes(searchText);
    } else {
      return user?.receiver_profile?.[0]?.name
        ?.toLowerCase()
        .includes(searchText);
    }
  });

  const unsubscribeRef = useRef(null);

  useEffect(() => {
    if (!me?.data?.id) return; // nothing to do until user info is ready

    let localUnsubscribe = null;

    const initializeChat = async () => {
      try {
        // Authenticate with Firebase (no-op if already signed in)
        signInToFirebase();
        // Sync organisation users & current user record
        const serverUsersList = await fetchAllUsers();
        await updateFirebaseUser(me.data);

        // (Re)attach chat listener
        if (typeof unsubscribeRef.current === "function") {
          unsubscribeRef.current();
        }
        unsubscribeRef.current = getChatUserList(
          dispatch,
          me.data.id,
          serverUsersList,
        );
        localUnsubscribe = unsubscribeRef.current;
        setHasInitialLoad(true);
      } catch (err) {
        console.error("Chat initialization error", err);
      }
    };

    initializeChat();

    // cleanup
    return () => {
      if (typeof localUnsubscribe === "function") {
        localUnsubscribe();
      }
    };
  }, [me]);
  return (
    <>
      {/* <CircularProgressBar selectedValue={1} /> */}
      <div className="chatGrid">
        <div className="userBox">
          <div className="inbox-wrapper h-100">
            <div className="innerContainer pe-0 inboxChatHeader">
              <div className="titleWrapper">
                <h2>Messages</h2>
                <div className="actionBoxWrapper d-flex align-items-center">
                  <ExpandableSearch
                    className="ps-3"
                    setSearchText={setSearchText}
                  />
                  <div
                    className="icon cursor-pointer"
                    onClick={() => {
                      setNewChat(!newChat);
                      if (!selectedUser) {
                        dispatch(setSelectedUser({}));
                      }
                    }}
                  >
                    <RoundedEditIcon />
                  </div>
                </div>
              </div>
            </div>

            {!hasInitialLoad ? (
              <div className="loading-icon-center">
                {tableLoader(true).indicator}
              </div>
            ) : (
              <UserList users={filteredUsers} onItemClick={handleItemClick} />
            )}
          </div>
        </div>
        <div className="chatBox">
          <div className="chatWrapperBox">
            {selectedUser && (
              <ChatWindowV2 newChat={newChat} setNewChat={setNewChat} />
            )}
            {!selectedUser && newChatDefault && (
              <div className="chatWrapperBox__newChat">
                <NewChat
                  key={"newChat"}
                  ref={newChatRef}
                  setNewChat={setNewChat}
                  setNewChatDefault={setNewChatDefault}
                />
              </div>
            )}
            {!selectedUser && newChatDefault && (
              <div className="noSearchData chat-empty-state">
                <NoDataIcon />
                <h5>Select a thread or start a chat.</h5>
                <button
                  type="button"
                  className="chat-empty-state__action"
                  onClick={() => newChatRef.current?.openSendTo()}
                >
                  Send Message
                </button>
              </div>
            )}

            {/* {newChat && <NewChat setNewChat={setNewChat} />} */}
          </div>
        </div>
      </div>
      <GenericModal
        show={showGenericModal}
        onHide={() => setShowGenericModal(false)}
        setModalShow={setShowGenericModal}
        modalTitle={"Create New Group"}
        pro={"Pro Tip:"}
        modalDesc={
          <>
            <div style={{ padding: "0 38px", textAlign: "left" }}>
              <b>Pro Tip:</b> Name your group, add your members, then upload a
              custom photo that represents this group.
            </div>
          </>
        }
        size={"lg"}
        bodyComponent={
          <NewGroupChatModal
            setModalShow={setShowGenericModal}
            buttonTrue={true}
            handleNewGroupChatFunc={handleNewGroupChatFunc}
          />
        }
      />
    </>
  );
};

export default Chat;
